import { Link, useNavigate } from "react-router-dom";
import { euro, specList } from "../api/shop";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { items, subtotal, count, setQuantity, remove } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="wrap" style={{ padding: "60px 0 90px" }}>
        <div className="state">
          <h3>Tu carrito está vacío</h3>
          <p>Cuando añadas un móvil, aparecerá aquí.</p>
          <Link to="/moviles" className="btn btn--lg">
            Ver móviles
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="wrap pagehead">
        <p className="eyebrow">Paso 1 de 2</p>
        <h1 style={{ fontSize: "clamp(1.9rem, 4vw, 2.8rem)" }}>Tu carrito</h1>
      </div>

      <div className="wrap twocol">
        <div className="lines">
          {items.map((item) => {
            const specs = specList(item.specs);
            return (
              <div className="line" key={item.sku}>
                <Link to={`/movil/${encodeURIComponent(item.sku)}`}>
                  <img className="line__img" src={item.image} alt={item.name} />
                </Link>

                <div>
                  <p className="eyebrow">{item.brand}</p>
                  <Link to={`/movil/${encodeURIComponent(item.sku)}`} className="line__title">
                    {item.name}
                  </Link>

                  {specs.length > 0 && (
                    <div className="specs" style={{ marginTop: 8 }}>
                      {specs.slice(0, 3).map((spec) => (
                        <span key={spec}>{spec}</span>
                      ))}
                    </div>
                  )}

                  <div className="line__controls">
                    <div className="qty">
                      <button
                        onClick={() => setQuantity(item.sku, item.quantity - 1)}
                        disabled={item.quantity <= 1}
                        aria-label={`Quitar una unidad de ${item.name}`}
                      >
                        −
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() => setQuantity(item.sku, item.quantity + 1)}
                        disabled={item.quantity >= 10}
                        aria-label={`Añadir una unidad de ${item.name}`}
                      >
                        +
                      </button>
                    </div>

                    <button className="remove" onClick={() => remove(item.sku)}>
                      Quitar
                    </button>
                  </div>
                </div>

                <div className="line__right">
                  <div style={{ fontSize: "1.1rem" }}>{euro(item.price * item.quantity)} €</div>
                  {item.quantity > 1 && (
                    <div style={{ fontSize: "0.78rem", color: "var(--stone)" }}>
                      {euro(item.price)} € / ud.
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <aside className="summary">
          <h3>Resumen</h3>

          <div className="summary__row">
            <span>
              Subtotal ({count} {count === 1 ? "artículo" : "artículos"})
            </span>
            <span>{euro(subtotal)} €</span>
          </div>

          <div className="summary__row">
            <span>Envío</span>
            <span>Gratis</span>
          </div>

          <div className="summary__total">
            <span>Total</span>
            <b>{euro(subtotal)} €</b>
          </div>

          <p style={{ fontSize: "0.8rem", color: "var(--stone)", margin: "8px 0 18px" }}>
            IVA y canon digital incluidos.
          </p>

          <button className="btn btn--block btn--lg" onClick={() => navigate("/pago")}>
            Continuar al pago
          </button>

          <Link to="/moviles" className="btn btn--ghost btn--block" style={{ marginTop: 10 }}>
            Seguir comprando
          </Link>
        </aside>
      </div>
    </>
  );
}
